import React from 'react'
import { string, bool } from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useAtSize, PersonBlock } from '@fs/zion-ui'
import useRelationTransKey from '../../../../shared/hooks/useRelationTransKey'
import { formatName } from '../../../../shared/helpers/name_formatting'
import { getGender } from '../../../../shared/helpers/person_Helper'

const PersonImage = ({ gender, portraitThumbnailLink, children, genderType }) => {
  const atSize = useAtSize()
  const src = portraitThumbnailLink ?? ''

  return (
    <>
      <PersonBlock
        size={atSize({ default: 'xl', xsm: 'xl' })}
        name=""
        avatarProps={{ sex: gender ? gender?.toLowerCase() : getGender(genderType), src }}
      />
      {children}
    </>
  )
}
export default function SliderProfileImage({ needsFormatting, ...relation }) {
  const [t] = useTranslation()
  const relationTransKey = useRelationTransKey(relation)
  const formattedName =
    needsFormatting && relation.displayName.length > 14
      ? `${formatName(relation.displayName).slice(0, 13)}...`
      : formatName(relation.displayName)

  return (
    <PersonImage {...relation}>
      <div className={relation.isActive ? 'details active' : 'details'}>
        <div className="name">{formattedName}</div>
        <div className="relation">{relationTransKey ? t(`wcf.person-header.relation.${relationTransKey}`) : ''}</div>
      </div>
    </PersonImage>
  )
}
SliderProfileImage.propTypes = {
  gender: string.isRequired,
  portraitThumbnailLink: string,
  needsFormatting: bool,
}
